import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
/** Why the server left an election as it was in an event-wide change. */
export var ESkippedElectionReason;
(function (ESkippedElectionReason) {
    /** With Seal at close, closed voting stays closed (VOTE-FREEZE). */
    ESkippedElectionReason["BALLOT_BOX_SEAL_POLICY"] = "ballot-box-seal-policy";
})(ESkippedElectionReason || (ESkippedElectionReason = {}));
/** The explanation of one skipped election, in the viewer's language. */
export var skippedElectionText = function (t, _a) {
    var election_id = _a.election_id, election_name = _a.election_name, reason = _a.reason;
    var name = election_name || election_id;
    return reason === ESkippedElectionReason.BALLOT_BOX_SEAL_POLICY
        ? t("publish.skippedElections.ballotBoxSealPolicy", { name: name })
        : t("publish.skippedElections.other", { name: name, reason: reason });
};
/**
 * The elections an event-wide Start or Resume left as they were, each with
 * the server's reason, until the administrator dismisses the list.
 */
export var SkippedElectionsAlert = function (_a) {
    var skipped = _a.skipped, onClose = _a.onClose;
    var t = useTranslation().t;
    if (!skipped.length)
        return null;
    return (_jsxs(Alert, { severity: "info", onClose: onClose, closeText: t("publish.skippedElections.dismiss"), sx: { mb: 2 }, children: [_jsx(AlertTitle, { children: t("publish.skippedElections.title", { count: skipped.length }) }), _jsx(Box, { component: "ul", sx: { m: 0, pl: 2 }, children: skipped.map(function (election) { return (_jsx("li", { children: skippedElectionText(t, election) }, election.election_id)); }) })] }));
};
